import React from 'react';
import classes from './Support.module.css';
import { SupportFiles } from '../../components/Support/SupportFiles/SupportFiles';

import { SupportFaq } from '../../components/Support/SupportFaq/SupportFaq';
import { supportClient } from '../../networking/client';
import { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import POSITION = toast.POSITION;
import { useTranslation } from '../../hooks/useTranslations';

type SupportFileType = {
  data: {
    attributes: {
      id: number;
      name: string;
      mime: string;
      size: number;
      url: string;
    };
  };
};

export type SupportItemType = {
  id: number;
  createdAt: string;
  ShortDescription: string;
  Title: string;
  File: SupportFileType;
  VideoLength: string;
  Position: string;
  locale: string;
};

export type FaqType = {
  description: string;
  title: string;
  position: number;
};

type ResponseType = {
  data: {
    attributes: {
      BusinessFunctions: SupportItemType[];
    };
  };
};

type FaqResponseType = {
  data: {
    attributes: { faq: FaqType[] };
  };
};

const MACHINES = 'machines';
const FAQ = 'support.faq';

const Support: React.FC = () => {
  const { translations } = useTranslation();
  const tabs = [MACHINES, FAQ];
  const [selectedTab, setSelectedTab] = React.useState<string>(MACHINES);

  const [businessFunction, setBusinessFunctions] = React.useState<SupportItemType[]>([]);
  const [faq, setFaq] = React.useState<FaqType[]>([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response: AxiosResponse<ResponseType> = await supportClient.get(
          '/api/business-function?populate=deep'
        );
        const faqResponse: AxiosResponse<FaqResponseType> = await supportClient.get(
          '/api/hp-faq?populate=deep'
        );
        if (!response.data.data) {
          toast.error(translations('placeholder.something.went.wrong'), {
            position: POSITION.BOTTOM_RIGHT,
          });
          return;
        }

        setBusinessFunctions(
          response.data.data.attributes.BusinessFunctions.filter(
            (bf) => bf.File.data.attributes.mime !== 'application/pdf'
          ).sort((a, b) => parseInt(a.Position) - parseInt(b.Position))
        );
        setFaq(faqResponse.data.data.attributes.faq);
      } catch (_) {
        toast.error(translations('placeholder.something.went.wrong'), {
          position: POSITION.BOTTOM_RIGHT,
        });
      }
    };
    fetchData();
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.tabsContainer}>
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`${classes.tab} ${selectedTab === tab ? classes.selectedTab : ''}`}
            onClick={() => setSelectedTab(tab)}
          >
            {translations(tab)}
          </div>
        ))}
      </div>

      {selectedTab === 'machines' && <SupportFiles data={businessFunction} />}
      {selectedTab === 'support.faq' && <SupportFaq faq={faq} />}
    </div>
  );
};

export { Support };
